import { render, staticRenderFns } from "./ListTrends.vue?vue&type=template&id=44f9518d&"
import script from "./ListTrends.vue?vue&type=script&lang=js&"
export * from "./ListTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListTrends.vue"
export default component.exports